// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var Welcome$ReactHooksTemplate = require("../Welcome.res.js");
var RichTextEditor$ReactHooksTemplate = require("../../common/RichTextEditor.res.js");

function WelcomePageEditorCard(props) {
  var onWelcomeChange = props.onWelcomeChange;
  var welcome = props.welcome;
  var titleLen = Utils$ReactHooksTemplate.stripHtml(Welcome$ReactHooksTemplate.title(welcome)).length;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "QUESTION CONTENT",
                            className: "sb-edit-card-kicker"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "Title"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: String(titleLen) + (" / " + String(100)),
                                            className: "sb-field-count"
                                          })
                                    ],
                                    className: "sb-field-label"
                                  }),
                              JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                                    value: Welcome$ReactHooksTemplate.title(welcome),
                                    onChange: (function (html) {
                                        Curry._1(onWelcomeChange, Welcome$ReactHooksTemplate.setTitle(welcome, html));
                                      }),
                                    placeholder: "Enter Title",
                                    label: "",
                                    minHeight: "48px",
                                    singleLine: true,
                                    showAlignment: false,
                                    showLists: false
                                  })
                            ],
                            className: "sb-field-group"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("span", {
                                          children: "Description (Optional)"
                                        }),
                                    className: "sb-field-label"
                                  }),
                              JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                                    value: Welcome$ReactHooksTemplate.description(welcome),
                                    onChange: (function (html) {
                                        Curry._1(onWelcomeChange, Welcome$ReactHooksTemplate.setDescription(welcome, html));
                                      }),
                                    placeholder: "Enter Description",
                                    label: "",
                                    minHeight: "96px"
                                  })
                            ],
                            className: "sb-field-group"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Button Text",
                                    className: "sb-field-label"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "sb-field-input",
                                    placeholder: "Start Survey",
                                    type: "text",
                                    value: Welcome$ReactHooksTemplate.button(welcome),
                                    onChange: (function ($$event) {
                                        var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                        if (Utils$ReactHooksTemplate.checkMaxLength24(value)) {
                                          return Curry._1(onWelcomeChange, Welcome$ReactHooksTemplate.setButton(welcome, value));
                                        }
                                        
                                      })
                                  })
                            ],
                            className: "sb-field-group"
                          })
                    ],
                    className: "sb-edit-card",
                    onClick: (function ($$event) {
                        $$event.stopPropagation();
                      })
                  }),
              className: "sb-center-editor"
            });
}

var make = WelcomePageEditorCard;

exports.make = make;
/* react/jsx-runtime Not a pure module */
